import React from 'react';
import { useTranslation } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from "react-router-dom";
import TableOnSteroids from '../../../../../frontend/components/components/utils/TableOnSteroids';
import configureStore from '../../../../../frontend/components/store/configureStore';
import ComponentMap, { DEFAULT_COLUMNS } from './CorgisComponentMap.js';

const store = configureStore();

function CorgisTableOnSteroids() {
  const { t } = useTranslation();
  return (
    <div className="styles-section row" id="corgis-table">
      <div className='home-page-content col-12'>
        <Provider store={store}>
          <Router >
            <TableOnSteroids
              tableId="corgis"
              objectsUrl="/api/v1/influencers/influencers/corgis"
              objectType="userOffer"
              componentMap={ComponentMap}
              defaultColumns={DEFAULT_COLUMNS}
              title="Campaigns"
              hideFilters={true}
              hideSearch={true}
              styleVersion='v4'
              className='knowledge-table-example'
            />
          </Router>
        </Provider>
      </div>
    </div>
  )
}

export default CorgisTableOnSteroids;
